import { BrandColors } from '../theme';

export const inputtextTokens = {
    root: {
        background: BrandColors.surface[0],
        borderColor: BrandColors.primary[200],
        hoverBorderColor: BrandColors.primary[400],
        focusBorderColor: BrandColors.primary[500],
        invalidBorderColor: BrandColors.red[500],
        color: BrandColors.surface[700],
        disabledColor: BrandColors.surface[400],
        placeholderColor: BrandColors.surface[400],
        paddingX: '12px',
        paddingY: '12px',
        borderRadius: '4px',
    },
};
